class CardProduct extends HTMLElement {
    constructor () {
        super();
        this.productHandle = this.querySelector('.js-more-info').dataset.handle;
         this.drawer = document.querySelector('quickview-drawer');
         this.moreInfo = this.querySelector('.js-more-info');
        this.moreInfo.addEventListener('click', this.openDrawer.bind(this));
    }
    openDrawer(e) {
        e.preventDefault();
        this.drawer.renderProduct(this.productHandle);
    }

    
}

customElements.define('card-product', CardProduct);